module.exports = __webpack_public_path__ + "nc_static/media/sw-not-authorized.4f2fdd66.svg";